import ColumnAmChart from './ColumnAmChart';

export default ColumnAmChart;
